import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";
import TomSelect from "tom-select";

export default class extends Controller {
  static targets = ["select", "list", "item"];
  static values = { itemUrl: String, options: Array };

  connect() {
    this.tomSelect = new TomSelect(this.selectTarget, {
      valueField: "id",
      labelField: "label",
      searchField: ["label", "description"],
      maxItems: 1,
      options: this.optionsValue,
    });
  }

  disconnect() {
    this.tomSelect.destroy();
  }

  async add() {
    const id = this.tomSelect.getValue();
    if (!id || this.isListed(id)) return this.tomSelect.clear();

    const response = await fetch(this.itemUrlValue.replace(":id", id), {
      headers: { Accept: "text/vnd.turbo-stream.html" },
    });
    Turbo.renderStreamMessage(await response.text());
    this.tomSelect.clear();
  }

  itemTargetConnected(item) {
    const { id, label, description } = item.dataset;
    if (!this.tomSelect) return;

    this.tomSelect.addOption({ id, label, description });
    this.dispatch("changed");
  }

  itemTargetDisconnected() {
    this.dispatch("changed");
  }

  remove(event) {
    event.target.closest("[data-searchable-list-target='item']").remove();
  }

  isListed(id) {
    return this.itemTargets.some((item) => item.dataset.id === id);
  }
}
